import type { Me, Permission, Scope } from "../api/contracts";

// RBAC as UX (ADR 0015 §3.3): the shell shows only what the principal's grants
// permit. This is convenience, NOT security — the API enforces every action
// regardless, so a hidden control still fails closed server-side.
//
// Scope ordering: own ⊂ team ⊂ all. A grant satisfies a requirement if its scope
// is at least as broad as the one asked for.
const SCOPE_RANK: Record<Scope, number> = { own: 1, team: 2, all: 3 };

export function hasGrant(
  me: Me | null | undefined,
  permission: Permission,
  minScope: Scope = "own",
): boolean {
  if (!me) return false;
  const need = SCOPE_RANK[minScope];
  return me.permissions.some((g) => g.permission === permission && SCOPE_RANK[g.scope] >= need);
}

/** True if the principal holds ANY of the listed permissions (at >= own). */
export function hasAnyGrant(me: Me | null | undefined, permissions: Permission[]): boolean {
  return permissions.some((p) => hasGrant(me, p));
}
